module.exports = __webpack_public_path__ + "img/virtual_fan_5.34b26a2.jpg";